<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="createContenido"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mEditionAssetContentsModalCreateVersion.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <AtomInputPrimary
          v-model="version.contenido.nombre"
          :inputError="$v.version.contenido.nombre.$error"
          :label="$t('mEditionAssetContentsModalCreateVersion.inputs.nombre.label')"
          :messageError="messageErrorNombre"
          name="nombre"
          type="text"
          @blur="$v.version.contenido.nombre.$touch()"
        />
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mEditionAssetContentsModalCreateVersion.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeEditionAssetContentsModalCreateVersion',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionAssetContentsModalCreateVersion.buttonPrimary'),
        class: 'a-button-assets-primary',
        sending: false,
        type: 'submit'
      },

      version: {
        academia: '',
        proyecto: '',
        contenido: {
          nombre: '',
          titulo: ''
        }
      }
    }
  },

  validations: {
    version: {
      contenido: {
        nombre: {
          required
        }
      }
    }
  },

  computed: {
    messageErrorNombre () {
      return this.$validation.getValidationMessage('mEditionAssetContentsModalCreateVersion', this.$v.version.contenido.nombre, 'contenido', 'nombre')
    }
  },

  watch: {
    'version.contenido.nombre' () {
      this.version.contenido.titulo = this.version.contenido.nombre
    }
  },

  created () {
    this.version.academia = this.$store.getters.getAcademyData.id
    this.version.proyecto = this.$route.params.id
  },

  methods: {
    createContenido () {
      this.$v.$touch()
      if (!this.$v.$invalid && !this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.create('contenido', 'createContenido', this.version)
          .then(response => {
            this.$modal.updateData('readElement')
            this.$modal.closeModal()
            this.$alerts.pushAlert('mEditionAssetContentsModalCreateVersion', 'createContenido', 'success')
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionAssetContentsModalCreateVersion', 'createContenido', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
